import {
  GeneralObject,
  TDPListPayload,
  TDPListResponse,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const deliveryPartnerService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      addUpdateDPDetails: builder.mutation<
        GeneralObject,
        GeneralObject
      >({
        query: (data) => {
          return {
            url: 'delivery-partner',
            method: 'PUT',
            data,
          };
        },
      }),
      getPartnerDetailsById: builder.query<
        GeneralObject,
        string
      >({
        query: (dpId) => ({
          method: 'GET',
          url: `delivery-partner/${dpId}`,
        }),
      }),
      getAllPartnerDetails: builder.query<
        { data: TDPListResponse[]; totalCount: number },
        TDPListPayload
      >({
        query: (params) => ({
          method: 'GET',
          url: `delivery-partners`,
          params,
        }),
        transformResponse: (
          data: TDPListResponse[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
      deleteDeliveryPartner: builder.mutation<
        { message: string },
        number
      >({
        query: (dpId) => {
          return {
            url: `delivery-partner/${dpId}`,
            method: 'DELETE',
          };
        },
      }),
    }),
  });

export const {
  useAddUpdateDPDetailsMutation,
  useGetPartnerDetailsByIdQuery,
  useGetAllPartnerDetailsQuery,
  useDeleteDeliveryPartnerMutation,
} = deliveryPartnerService;
